<template>
  <div class="grid-y">
    <FooterSignUpMcom v-if="!isInternational" class="footer-section" />
    <FooterCreditCardMcom v-if="!isInternational" class="footer-section" />
    <FooterSocialLinksCommon class="footer-section" :class="{ 'social-links': isInternational }">
      <span class="white">Connect With Us</span>
    </FooterSocialLinksCommon>
    <FooterAppSectionCommon v-if="!isInternational" class="footer-section footer-apps" title="Macy's" />
  </div>
</template>

<script setup>
import { computed } from 'vue';

const pageData = usePageData();
const isInternational = computed(() => pageData.navigation.context.isInternational);
</script>

<style lang="scss" brand="mcom" scoped>
@import '~/assets/scss/mixins.mcom.scss';

.footer-section {
  position: relative;
  @include padding-top-m;
  @include padding-bottom-m;

  &:not(:first-child) {
    &::before {
      position: absolute;
      top: 0;
      left: -20px;
      width: 100vw;
      height: 1px;
      content: '';
      background-color: $gray-1-color;

      @include breakpoint(large up) {
        left: 0;
        width: 100%;
      }
    }
  }

  &:last-child {
    @include padding-bottom-z;
    border-bottom: none;
  }

  @include breakpoint(large up) {
    &:first-child {
      @include padding-top-z;
    }
  }
}
.social-links {
  @include padding-top-z;
}

@include breakpoint(large up) {
  .footer-apps {
    display: none;
  }
}
</style>
